import axios from 'axios';

export const supplierApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/supplier-stk`,
    headers: {
        'Content-Type': 'application/json'
    }
})